import { useMemo, useState } from "react";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";

const SmartMoneySection = ({
  dashboardIndexData,
  selectedIndex,
  navigate,
  isInWatchlist,
  handleAdd,
}) => {
  const [smartMoneyTab, setSmartMoneyTab] = useState("accumulation");

  // Extract smart money data from the index cache
  const smartMoney = dashboardIndexData?.smart_money;

  const accumulation = useMemo(() => {
    if (!smartMoney?.stocks) return [];
    return Object.entries(smartMoney.stocks)
      .filter(([, v]) => v?.signal === "accumulation")
      .map(([symbol, data]) => ({ symbol, ...data }))
      .sort((a, b) => (b.score || 0) - (a.score || 0))
      .slice(0, 10);
  }, [smartMoney]);

  const distribution = useMemo(() => {
    if (!smartMoney?.stocks) return [];
    return Object.entries(smartMoney.stocks)
      .filter(([, v]) => v?.signal === "distribution")
      .map(([symbol, data]) => ({ symbol, ...data }))
      .sort((a, b) => (b.score || 0) - (a.score || 0))
      .slice(0, 10);
  }, [smartMoney]);

  const currentList =
    smartMoneyTab === "accumulation" ? accumulation : distribution;

  if (!smartMoney) {
    return (
      <div className="test-card-head">
        <h2>Smart Money</h2>
        <p style={{ color: "#6b7280", padding: "1rem 0" }}>
          Smart money data not available for {selectedIndex}
        </p>
      </div>
    );
  }

  return (
    <div>
      <div className="test-card-head">
        <div className="card-head test-head-dash">
          <h2>Smart Money — {selectedIndex}</h2>
        </div>

        <div className="test-card-stats">
          <p style={{ color: "#16a34a" }}>
            <IoMdTrendingUp />
            Accumulation - {accumulation.length}
          </p>
          <p style={{ color: "#dc2626" }}>
            <IoMdTrendingDown />
            Distribution - {distribution.length}
          </p>
        </div>
      </div>

      <div className="mobile-market-tabs" style={{ marginBottom: "1rem" }}>
        <button
          className={smartMoneyTab === "accumulation" ? "active" : ""}
          onClick={() => setSmartMoneyTab("accumulation")}
        >
          Accumulation
        </button>
        <button
          className={smartMoneyTab === "distribution" ? "active" : ""}
          onClick={() => setSmartMoneyTab("distribution")}
        >
          Distribution
        </button>
      </div>

      <div className="smart-money-list">
        {currentList.length === 0 ? (
          <p style={{ color: "#6b7280", padding: "0.5rem 0" }}>
            No {smartMoneyTab} signals found
          </p>
        ) : (
          currentList.map((stock) => (
            <div className="card-row" key={stock.symbol}>
              <div className="left">
                <p
                  className="name"
                  onClick={() =>
                    navigate(
                      `/stockdetail/${stock.symbol}/${stock.security_id || ""}`,
                    )
                  }
                >
                  {stock.symbol}
                </p>
                <p
                  className="volume"
                  style={{ fontSize: "12px", color: "#6b7280" }}
                >
                  Score: {stock.score?.toFixed(2) || "--"}
                </p>
              </div>

              <div className="right">
                <button
                  className={
                    smartMoneyTab === "accumulation" ? "buy-btn" : "sell-btn"
                  }
                >
                  {smartMoneyTab === "accumulation"
                    ? "Accumulating"
                    : "Distributing"}
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default SmartMoneySection;
